import React from "react";
import styled from "@emotion/styled";
import { deepOrange } from "@mui/material/colors";
import { Badge, Grid, Avatar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useState, useEffect } from "react";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const FooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const FooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${(props) =>
    props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${(props) => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const SidebarFooter = ({ ...rest }) => {

  const { user, getUserInfo } = useAuth();
  const navigate = useNavigate();

  const handleNavigateToProfile = () => {
    navigate('/pages/profile');
  }

  return (
    <Footer {...rest}>
      <Grid container spacing={2}>
        <Grid item>
          <FooterBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
            onClick={handleNavigateToProfile}
          >
            {/*!!user &&
              <Avatar
                sx={{
                  bgcolor: deepOrange[500],
                  fontWeight: 'bold',
                  fontSize: 20,
                  margin: 'auto',
                }}
                alt={user.displayName}
                src={user.avatar}
              >
                {sessionStorage.getItem('nomeAvatar')}
              </Avatar>*/}
            {/* Demo data */}
            {!user && (
              <Avatar
                sx={{
                  bgcolor: deepOrange[500],
                  fontWeight: 'bold',
                  fontSize: 15,
                  margin: 'auto',
                  cursor: 'pointer'
                }}
                alt="Nome utente"
              >
                {sessionStorage.getItem('nomeAvatar')}

              </Avatar>
            )}
          </FooterBadge>
        </Grid>
        <Grid item>
          {!!user && (
            <FooterText variant="body2" onClick={handleNavigateToProfile}>{user.displayName}</FooterText>
          )}

          <FooterText variant="body2" onClick={handleNavigateToProfile}>{sessionStorage.getItem('nome') + ' ' + sessionStorage.getItem('cognome')}</FooterText>

          <FooterSubText variant="caption">{sessionStorage.getItem('agenzia')}</FooterSubText>

        </Grid>
      </Grid>
    </Footer>
  );
};

export default SidebarFooter;
